<template>
  <div class="agree-accept-box">
    <div class="inner">
      <div>
        <div class="cell-list">
          <div class="cell" style="" @click="returnMethodHandle">
            <div class="label">
              退货方式
              <span>*</span>
            </div>
            <div class="content">
              <span>{{ selectReturnMethod.name }}</span>
              <van-icon class="arrow" name="arrow" />
            </div>
          </div>
          <!-- 现场退货的内容 -->
          <div v-if="selectReturnMethod.id == 2">
            <!-- 服务点也是现场退货才有 -->
            <div @click="servicePointHandle" class="cell">
              <div class="label">
                服务点
                <span>*</span>
              </div>
              <div class="content">
                <span :style="{'color': seleceServicePoint.name == '请选择' ? '#CCCCCC' : '#171A1D'}">{{ seleceServicePoint.name }}</span>
                <van-icon class="arrow" name="arrow" />
              </div>
            </div>
            <!-- 企业处置的时候没有处理人和不能指派他人 -->
            <div v-if="userInfo && userInfo.roleList[0] !== 'CompanyHandler'" class="cell">
              <div class="label">
                处理人
                <span>*</span>
              </div>
              <div class="content">
                <van-radio-group v-model="radio" direction="horizontal">
                  <van-radio name="1">
                    本人处理
                    <template #icon="props">
                      <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                    </template>
                  </van-radio>
                  <van-radio name="2">
                    指派他人
                    <template #icon="props">
                      <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                    </template>
                  </van-radio>
                </van-radio-group>
              </div>
            </div>
            <div v-if="radio === '2'" class="cell" @click="assignPersonnelPickerShow = true">
              <div class="label">指派人员<span>*</span></div>
              <div class="content">
                <span
                  :class="{'grayfont': assignPersonnelSelect.name === '请选择'}"
                >{{ assignPersonnelSelect.name }}</span>
                <van-icon class="arrow" name="arrow" />
              </div>
            </div>
          </div>
          <!-- 邮寄退货内容 -->
          <div v-if="selectReturnMethod.id == 1">
            <div class="cell noboderboottom">
              <div class="label">
                退货地址
                <span>*</span>
              </div>
              <div class="content">
                <van-radio-group v-model="addressRadio" @change="selectConsigneeHandle(selectConsignee)" direction="horizontal">
                  <van-radio name="1">
                    立即反馈
                    <template #icon="props">
                      <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                    </template>
                  </van-radio>
                  <van-radio name="2">
                    稍后反馈
                    <template #icon="props">
                      <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                    </template>
                  </van-radio>
                </van-radio-group>
              </div>
            </div>
            <!-- 立即反馈内容 -->
            <div v-if="addressRadio == '1'" class="child-form">
              <div class="cell secondary-cell" @click="consigneePickerHandle">
                <div class="label">
                  收货方
                  <span>*</span>
                </div>
                <div class="content">
                  <span>{{ selectConsignee.name }}</span>
                  <van-icon class="arrow" name="arrow" />
                </div>
              </div>
              <div v-if="!pasteAddressVal" class="cell secondary-cell paddingBottom0" style="border-bottom:none;">
                <van-field
                  v-model="pasteAddressVal"
                  @blur="changePasteAddress"
                  class="address-inp"
                  placeholder="粘贴地址信息，自动拆分识别"
                />
                <img class="address-inp-icon" src="../../../../assets/refund/icon_UpPicture.png" alt />
              </div>
              <!-- 聚焦输入框 -->
              <div v-else class="cell cell-bg text-cell">
                <van-field
                  autosize
                  type="textarea"
                  ref="AddressTextarea" 
                  v-model="pasteAddressVal" 
                  class="textarea"
                />
                <!-- <textarea ref="AddressTextarea" v-model="pasteAddressVal" class="textarea" name id cols="30" rows="10"></textarea> -->
                <img class="clear-icon" @click="pasteAddressVal = ''" src="../../../../assets/refund/icon_UpPicture@2x.png" alt="">
                <div @click="fillInAddress" class="Fill-in-btn">填入</div>
                <!-- <van-icon @click="pasteAddressVal = ''" class="clear-icon" name="clear" /> -->
              </div>
              <div class="cell secondary-cell input-cell">
                <div class="label">
                  收货人
                  <span>*</span>
                </div>
                <div class="content">
                  <van-field v-model="receiver" placeholder="请输入" />
                </div>
              </div>
              
              <div class="cell secondary-cell input-cell">
                <div class="label">
                  联系方式
                  <span>*</span>
                </div>
                <div class="content">
                  <van-field v-model="contactInformation" placeholder="请输入" />
                </div>
              </div>
              <div class="cell secondary-cell pading-right16" @click="addressPickerShow = true">
                <div class="label">
                  收货地址
                  <span>*</span>
                </div>
                <div class="content">
                  <span :class="{'grayfont': ShippingAddress === '请选择'}">{{ ShippingAddress }}</span>
                  <van-icon class="arrow" name="arrow" />
                </div>
              </div>
              <div class="cell secondary-cell noboderboottom input-cell" :class="[address.length > 0 ? 'Address-input' : '']">
                <div class="label">
                  详细地址
                  <span>*</span>
                </div>
                <div class="content address-content" :class="[address.length === 0 ? 'setHeight24' : '']">
                  <van-field v-model="address" autosize input-align="right" type="textarea" placeholder="请输入" />
                </div>
              </div>
            </div>
            <!-- 监理角色才可以选择处理人 -->
            <div v-if="userInfo && userInfo.roleList[0] !== 'CompanyHandler'" class="cell">
              <div class="label">
                处理人
                <span>*</span>
              </div>
              <div class="content">
                <van-radio-group v-model="radio" direction="horizontal">
                  <van-radio name="1">
                    本人处理
                    <template #icon="props">
                      <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                    </template>
                  </van-radio>
                  <van-radio name="2">
                    指派他人
                    <template #icon="props">
                      <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                    </template>
                  </van-radio>
                </van-radio-group>
              </div>
            </div>
            <div v-if="radio === '2'" class="cell" @click="assignPersonnelPickerShow = true">
              <div class="label">指派人员<span style="margin-left: 3px;">*</span></div>
              <div class="content">
                <span :class="{'grayfont': assignPersonnelSelect.name === '请选择'}">{{ assignPersonnelSelect.name }}</span>
                <van-icon class="arrow" name="arrow" />
              </div>
            </div>
          </div>
        </div>
        <div class="supplement-box">
          <p class="title">补充说明</p>
            <van-field
                class="textarea"
                v-model="txt"
                autosize
                type="textarea"
                maxlength="500"
                placeholder="请输入"
              />
    
          <div class="tip">
            <span @click="txt = ''" class="clear" :style="{'opacity': txt.length === 0 ? 0 : 1}">清空</span>
            <span>{{ txt.length }}/500</span>
          </div>
        </div>
      </div>
      <div class="confirmbtn" :style="{'background': confirmBtnDisable ? '#9bd9ba' : '#36B374'}" @click="onSubmit">确定</div>
    </div>
    <!-- 退货方式和服务点弹出框 -->
    <list
      ref="returnMethodsPicker"
      @select="selectReturnMethodHandle"
      @close="selectReturnMethodHandle"
      :datalist="returnMethodsList"
      :header="'选择退货方式'"
    />
    <!-- 服务点弹出框 -->
    <list
      ref="servicePointPicker"
      @select="selectServicePointHandle"
      @close="selectServicePointHandle"
      :datalist="servicePointList"
      :header="'选择服务点'"
    />
    <!-- <van-popup v-model="servicePointPickerShow" position="bottom" :style="{ height: '50%' }">
      <van-area
        @confirm="confirm"
        @cancel="servicePointPickerShow = false"
        value="2"
        :area-list="servicePointList"
        :columns-num="1"
      />
    </van-popup>-->
    <!-- 指派人员弹出层 -->
    <van-popup
      class="assignPersonnelPicker-box"
      v-model="assignPersonnelPickerShow"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="header">
        <span class="title">选择指派人员</span>
        <van-icon
          @click="assignPersonnelPickerShow = false"
          size="12px"
          name="arrow-down"
          color="#A2A3A4"
        />
        
      </div>
      <div v-if="assignPersonnelList.length > 0" class="person-list">
        <div
          v-for="(item, index) of assignPersonnelList"
          :key="index"
          class="person-item"
          @click="selectPerson(item)"
        >
          <span class="name">{{ item.name }}</span>
          <img class="select-icon" v-if="item.id === assignPersonnelSelect.id" src="../../../../assets/refund/icon_check@2x.png" alt="">
        </div>
      </div>
      <div v-else class="box1">
        <img src="../../../../assets/empty/ic_wuxingxi.png" />
        <p class="tip1">暂无数据</p>
      </div>
    </van-popup>
    <!-- 收货方弹出框 -->
    <list
      ref="ConsigneePicker"
      @select="selectConsigneeHandle"
      @close="selectConsigneeHandle"
      :datalist="ConsigneeList"
      :header="'收货方'"
    />
    <!-- <van-popup
      class="assignPersonnelPicker-box"
      v-model="consigneePickerShow"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <div class="header">
        <span class="title">收货方</span>
        <van-icon @click="consigneePickerShow = false" size="12px" name="cross" color="#A2A3A4" />
      </div>
      <div class="person-list">
        <div
          v-for="(item, index) of ConsigneeList"
          :key="index"
          class="person-item"
          @click="selectConsigneeHandle(item)"
        >
          <span class="name">{{ item.name }}</span>
          <van-icon
            v-if="item.id === selectConsignee.id"
            class="select-icon"
            color="#36B374"
            name="success"
          />
        </div>
      </div>
    </van-popup>-->
    <!-- 收货地址弹出框 -->
    <van-popup
      class="assignPersonnelPicker-box"
      @close="addressPickerClose"
      v-model="addressPickerShow"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="header">
        <span class="title">收货地址</span>
        <van-icon @click="addressPickerShow = false" size="12px" color="#A2A3A4" name="arrow-down" />
      </div>
      <div class="tab-box">
        <div
          v-for="(item, index) in cityTabList"
          @click="addressTabClick(item, index)"
          :key="index"
          class="tab"
          :class="tabActive === item.code ? 'tab-active' : ''"
        >{{ item.shortName }}</div>
        <!-- <div class="tab-active">{{ 'yeyg' }}</div> -->
        <div v-if="cityTabList.length < 2" class="tab-active">请选择</div>
      </div>
      <div class="person-list" style="max-height: 310px;">
        <div
          v-for="(item, index) of tabPaneList"
          :key="index"
          class="person-item"
          @click.stop="selectArea(item)"
        >
          <span class="name">{{ item.shortName }}</span>
          <img class="select-icon" src="../../../../assets/refund/icon_check@2x.png" v-if="item.id === areaItem.id" alt="">
        </div>
      </div>
    </van-popup>
    <!-- <div class="btn-box">
      <div class="btn" :style="{'background': confirmBtnDisable ? '#9bd9ba' : '#36B374'}" @click="onSubmit">确定</div>
    </div> -->
  </div>
</template>

<script>
    import list from '../components/listPopup';
    import api from '../../../../service/modules/refund';
    import AddressParse from 'address-parse';
    import Vue from 'vue';
    import { Divider } from 'vant';
    Vue.use(Divider);

    export default {
        components: { list },
        computed: {
          formDataChange() {
            const {
              selectReturnMethod,
              seleceServicePoint,
              addressRadio,
              receiver,
              contactInformation,
              ShippingAddress,
              address,
              radio,
              assignPersonnelSelect,
              } = this
            return {
              selectReturnMethod,
              seleceServicePoint,
              addressRadio,
              receiver,
              contactInformation,
              ShippingAddress,
              address,
              radio,
              assignPersonnelSelect,
            }
          }
        },
        watch: {
          formDataChange: {
            immediate: true,
            handler (newVal, oldVal) {
            console.log('变了');
            let flag = false
            if (this.selectReturnMethod.id == 2) {
                if (this.seleceServicePoint.name == '请选择') {
                  flag = false
                }
            }
            if (this.addressRadio === '1' && this.selectReturnMethod.id === 1) {
                if (!this.receiver) {
                    flag = false
                } else if (!this.contactInformation) {
                    flag = false
                } else if (this.ShippingAddress === '请选择') {
                    flag = false
                } else if (!this.address) {
                    flag = false
                } else {
                    flag = true;
                }
            } else {
                flag = true;
            }
            if (flag) {
              if (this.radio === '2') {
                if (!this.assignPersonnelSelect.id) {
                  flag = false
                } else {
                  flag = true
                }
              } else {
                flag = true
              }
            }
            this.confirmBtnDisable = !flag
          }
          },
            pasteAddressVal (newVal, oldVal) {
                if (newVal) {
                    this.$nextTick(() => {
                        this.$refs.AddressTextarea.focus()
                    })
                }
            }
        },
        data () {
            return {
                pasteAddressVal: '', // 粘贴的地址
                ShippingAddress: '请选择', // 收货地址
                cityTabList: [], // 已选择的的地址,tab选项
                areaItem: {}, // 点击选中的area
                tabPaneList: [], // 对应tab的地区列表
                tabActive: '',
                tabAreaList: [], // tab选项相关的area
                allAreaList: [], // 所有地区列表
                areaList: [], // 选中的市相关的县
                addressPickerShow: false, // 收货地址弹框显示
                returnMethodPickerShow: false, // 退货方式弹框显示
                servicePointPickerShow: false, // 服务点弹框显示
                ConsigneeList: [
                    { name: '商家', id: 30 },
                    { name: '监理中心', id: 10 }
                ], // 收货方类型:商家、监理中心
                selectConsignee: { name: '监理中心', id: 10 }, // 选择的收货方
                consigneePickerShow: false,
                address: '', // 详细地址
                receiver: '', // 收货人
                contactInformation: '', // 联系方式
                txt: '', // 补充说明
                radio: '1',
                addressRadio: '2', // 立即反馈和稍后反馈
                activeIcon: require('../../../../assets/refund/checkbox-select.png'),
                inactiveIcon: require('../../../../assets/refund/checkbox-defalut.png'),
                assignPersonnelPickerShow: false, // 打开指派人员选择面板
                assignPersonnelList: [], // 指派人员列表
                popupType: '', // 弹出框类型：退货方式或服务点
                returnMethodsList: [
                    { name: '现场退货', id: 2 },
                    { name: '邮寄退货', id: 1 }
                ], // 退货方式
                selectReturnMethod: {
                    name: '现场退货',
                    id: 2
                }, // 所选退货方式
                servicePointList: [], // 用于弹窗显示服务点列表
                seleceServicePoint: {
                    name: '请选择'
                }, // 所选服务点
                assignPersonnelList: [], // 指派人员
                assignPersonnelSelect: {
                    name: '请选择'
                }, // 所选择的指派人员
                flowId: '',
                userInfo: {}, // 用户信息
                detailInfo: {}, // 退货单详情
                confirmBtnDisable: true, // 确定按钮状态，true为禁止
            };
        },
        created () {
            this.detailInfo = this.$route.query.data;
            this.flowId = this.$route.query.flowId;
            this.returnMethodInit();
            this.userInfo = JSON.parse(localStorage.getItem('refundUserInfo'));
            // 获取收货地址
            this.getCity();
            this.getAcceptMessage();
            // 获取服务点列表
            this.getServicePointList();
        },
        methods: {
            // 智能识别填入地址
            fillInAddress () {
                try {
                    if (this.pasteAddressVal.trim()) {
                        const result = AddressParse.parse(this.pasteAddressVal);
                        console.log(result, 'result')
                        if (result[0].province !== '云南省') {
                            return this.$toast('请输入云南省地址');
                        } else {
                          if (!result[0].city) {
                            return this.$toast('该市不存在');
                          }
                          if (!result[0].area) {
                            return this.$toast('无该区县');
                          }
                          this.cityTabList = [];

                            // 获取州市
                            this.allAreaList.map(i => {
                                if (i.name === result[0].city) {
                                  this.cityTabList[0] = i
                                }
                            });
                               // 获取区县
                            this.cityTabList[0].children.map(item => {
                                if (item.name === result[0].area) {
                                  this.cityTabList[1] = item
                                }
                            });
                            // 地址回显
                            this.tabPaneList = this.cityTabList[0].children
                            this.areaItem = this.cityTabList[1]
                            this.tabActive = this.cityTabList[1].code

                            this.receiver = result[0].name;
                            this.contactInformation = result[0].mobile;
                            this.address = result[0].details;
                            this.ShippingAddress = `${this.cityTabList[0].name}-${this.cityTabList[1].name}`;
                        }
                    }
                } catch (err) {
                    this.$toast('请输入云南省地址');
                    console.log(err, 'err')
                }
            },
            selectReturnMethodHandle (item) {
                this.selectReturnMethod = item;
            },
            // 点击服务点回调
            selectServicePointHandle (item) {
                this.seleceServicePoint = item;
            },
            // 退货方式初始化
            returnMethodInit () {
                if (this.detailInfo && this.detailInfo.finalRefundTypes) {
                    if (this.detailInfo.finalRefundTypes === 2) {
                        this.selectReturnMethod.name = '现场退货';
                        this.selectReturnMethod.id = 2;
                    } else if (this.detailInfo.finalRefundTypes === 1) {
                        this.selectReturnMethod.name = '邮寄退货';
                        this.selectReturnMethod.id = 1;
                    }
                } else {
                    if (this.detailInfo.refundType === 2) {
                        this.selectReturnMethod.name = '现场退货';
                        this.selectReturnMethod.id = 2;
                    } else if (this.detailInfo.refundType === 1) {
                        this.selectReturnMethod.name = '邮寄退货';
                        this.selectReturnMethod.id = 1;
                    }
                }
            },
            // 粘贴地址输入框失焦事件
            changePasteAddress () {
                // try {
                //     // 取出字符串的地址
                //     const address = this.pasteAddressVal;
                //     const regex =
                //         '(?<province>[^省]+省|.+自治区)(?<city>[^自治州]+自治州|[^市]+市|[^盟]+盟|[^地区]+地区|.+区划)(?<county>[^市]+市|[^县]+县|[^旗]+旗|.+区)?(?<town>[^区]+区|.+镇)?(?<village>.*)';
                //     const result = address.match(regex);
                //     this.ShippingAddress = result.groups.city + '-' + result.groups.county;
                //     this.address = result.groups.village;
                // } catch (err) {
                //     // this.$toast.fail('请输入正确的地址')
                // }
            },
            // 收货地址弹框关闭事件
            addressPickerClose () {
                let addressName = [];
                if (this.cityTabList.length > 0) {
                    this.cityTabList.map(item => {
                        addressName.push(item.shortName);
                    });
                    this.ShippingAddress = addressName.join(' - ');
                }
            },
            // 点击地区选择
            selectArea (item) {
                // 如果还没有选择地区，添加tab选项
                if (this.cityTabList.length === 0) {
                    this.cityTabList.push(item);
                    this.allAreaList.map(i => {
                        if (i.code === item.code) {
                            this.tabPaneList = i.children;
                        }
                    });
                } else if (this.cityTabList.length === 1) {
                    this.cityTabList.push(item);
                    this.addressPickerShow = false
                    // this.cityTabList[0] = item;
                } else if (this.cityTabList.length === 2) {
                    this.cityTabList[1] = item;
                }
                this.areaItem = item;
                this.tabActive = item.code;
            },
            // 邮寄退货的相关表单验证, 返回true为通过，false不通过
            formCheckPass () {
                if (this.selectReturnMethod.id == 2) {
                    if (this.seleceServicePoint.name == '请选择') {
                        return this.$toast('请选择服务点');
                    }
                }
                if (this.addressRadio === '1' && this.selectReturnMethod.id === 1) {
                    if (!this.receiver) {
                        return this.$toast('请输入收货人姓名');
                    } else if (!this.contactInformation) {
                        return this.$toast('请输入联系方式');
                    } else if (this.ShippingAddress === '请选择') {
                        return this.$toast('请选择收货地址');
                    } else if (!this.address) {
                        return this.$toast('请选择详细地址');
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            },
            // 初始化地区的显示
            areaInit () {
                if (this.cityTabList.length === 0) {
                    this.tabPaneList = this.allAreaList;
                } else if (this.cityTabList.length === 1) {
                }
            },
            // 获取云南省的下级地址
            getCity () {
                api.getCity().then(res => {
                    if (res.ret === 0 && res.data[0].children.length > 0) {
                        if (res.data[0].children.length > 0) {
                            this.allAreaList = res.data[0].children;
                            this.areaInit();
                        }
                    }
                });
            },
            // 地址tab选项点击事件
            addressTabClick (item, index) {
                this.tabActive = item.code;
                // 如果点击第一项
                if (index === 0) {
                    this.tabPaneList = this.allAreaList;
                    this.cityTabList = [];
                }
            },
            // 服务点列表
            getServicePointList () {
                // this.servicePointList.province_list = {};
                const param = {
                    basicId: this.detailInfo.basicId
                }
                api.servicePointList(param).then(res => {
                    if (res.ret === 0) {
                        this.servicePointList = res.data;
                        for (let i = 0; i < this.servicePointList.length; i++) {
                            if (this.servicePointList.isSelect) {
                                this.seleceServicePoint = this.servicePointList[i]
                                console.log(this.seleceServicePoint, 'this.seleceServicePoint')
                                break
                            }
                        }
                    }
                });
            },
            // 获取服务点和处理人
            getAcceptMessage () {
                api.getAcceptMessage({ flowId: this.flowId }).then(res => {
                    if (res.ret === 0) {
                        // this.seleceServicePoint = res.data.servicePoint;
                        this.assignPersonnelList = res.data.belongUserList;
                        this.assignPersonnelList.filter(item => {
                            return item.mobile !== this.userInfo.mobile
                        });
                    } else {
                        this.seleceServicePoint = {};
                        this.assignPersonnelSelect = [];
                    }
                });
            },
            // 退货方式和服务点确认事件
            confirm (val) {
                this.returnMethodPickerShow = false;
                this.servicePointPickerShow = false;
                if (this.popupType === 'returnMethod') {
                    this.selectReturnMethod = val[0];
                } else if (this.popupType === 'servicePoint') {
                    this.seleceServicePoint = val[0];
                }
            },
            // 提交
            onSubmit () {
                try {
                    if (this.formCheckPass() === true) {
                        // 邮寄退货的参数
                        const returnMailParam = {
                            deliveryObject: this.selectConsignee.id, // 收获对象
                            contact: this.receiver, // 联系人
                            contactTel: this.contactInformation, // 联系方式
                            province: '530000', // 省
                            city: this.cityTabList[0] ? this.cityTabList[0].code : '', // 市
                            county: this.cityTabList[1] ? this.cityTabList[1].code : '', // 区
                            address: this.address
                        };
                        if (this.radio === '2') {
                            // 指派他人
                            if (!this.assignPersonnelSelect.id) {
                                return this.$toast.fail('请选择指派人员');
                            } else {
                                let param = {};
                                if (this.addressRadio == '1') {
                                    param = {
                                        serviceId: this.seleceServicePoint.id,
                                        serviceName: this.seleceServicePoint.name,
                                        serviceType: this.seleceServicePoint.type,
                                        flowId: this.flowId,
                                        refundType: this.selectReturnMethod.id,
                                        context: this.txt,
                                        ...returnMailParam
                                    };
                                } else {
                                    param = {
                                        serviceId: this.seleceServicePoint.id,
                                        serviceName: this.seleceServicePoint.name,
                                        serviceType: this.seleceServicePoint.type,
                                        flowId: this.flowId,
                                        refundType: this.selectReturnMethod.id,
                                        context: this.txt
                                    };
                                }
                                api.accept(param).then(res => {
                                    if (res.ret === 0) {
                                        this.$toast({
                                            message: '已受理',
                                            icon: 'passed'
                                        });
                                        setTimeout(() => {
                                            this.$router.back();
                                        }, 1500);
                                    } else {
                                        this.$toast.fail(res.msg);
                                    }
                                });
                            }
                        } else if (this.radio === '1') {
                            // 本人处理
                            let param = {};
                            if (this.addressRadio == '1') {
                                param = {
                                    serviceId: this.seleceServicePoint.id,
                                    serviceName: this.seleceServicePoint.name,
                                    serviceType: this.seleceServicePoint.type,
                                    flowId: this.flowId,
                                    refundType: this.selectReturnMethod.id,
                                    context: this.txt,
                                    ...returnMailParam
                                };
                            } else {
                                param = {
                                    serviceId: this.seleceServicePoint.id,
                                    serviceName: this.seleceServicePoint.name,
                                    serviceType: this.seleceServicePoint.type,
                                    flowId: this.flowId,
                                    refundType: this.selectReturnMethod.id,
                                    context: this.txt
                                };
                            }
                            api.accept(param).then(res => {
                                if (res.ret === 0) {
                                    this.$toast({
                                        message: '已受理',
                                        icon: 'passed'
                                    });
                                    setTimeout(() => {
                                        this.$router.back();
                                    }, 1500);
                                } else {
                                    this.$toast.fail('请求错误');
                                }
                            }).catch(err => {
                              console.log('555');
                            });
                        }
                    }
                } catch (err) {
                    alert(err);
                }
            },
            returnMethodHandle () {
                try {
                    this.$refs['returnMethodsPicker'].init(this.selectReturnMethod);
                } catch (err) {
                    console.log(err);
                }
            },
            // 打开收货方弹框
            consigneePickerHandle () {
                try {
                    this.consigneePickerShow = true;
                    this.$refs['ConsigneePicker'].init(this.selectConsignee);
                } catch (err) {
                    console.log(err);
                }
            },
            // 打开服务点弹框
            servicePointHandle () {
                this.$refs['servicePointPicker'].init(this.seleceServicePoint);
            },
            // 选择退货方式或者服务点
            cellClick (type) {
                this.popupType = type;
                // 退货方式
                if (type === 'returnMethod') {
                    this.returnMethodPickerShow = true;
                } else if (type === 'servicePoint') {
                    // 服务点
                    this.servicePointPickerShow = true;
                }
            },
            // 选中指派人员
            selectPerson (item) {
                this.assignPersonnelSelect = item;
            },
            // 选中收货方
            selectConsigneeHandle (item) {
                this.selectConsignee = item;
                if (item.id == 10) {
                    api.currentUserDefaultDeliveryAddress().then(res => {
                        if (res.ret === 0 && res.data) {
                            this.receiver = res.data.contact;
                            this.ShippingAddress =
                                res.data.cityName + '-' + res.data.countyName;

                            let cityTabList = [];
                            cityTabList.push({
                                shortName: res.data.cityName,
                                code: res.data.cityCode
                            });
                            cityTabList.push({
                                shortName: res.data.countyName,
                                code: res.data.countyCode
                            });
                            this.cityTabList = cityTabList;
                            this.allAreaList.map(i => {
                                if (i.code === res.data.cityCode) {
                                    this.tabPaneList = i.children; // 区县
                                }
                            });
                            this.tabActive = res.data.countyCode;

                            this.contactInformation = res.data.tel;
                            this.address = res.data.address;
                        }
                    })
                }
            }
        }
    };
</script>
<style lang="less" scoped>
.agree-accept-box {
  .inner {
    padding: 0 16px 34px;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

  }
  .cell-list {
    margin-bottom: 24px;
    position: relative;

    .cell {
      padding: 20px 0;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .van-icon-arrow:before {
        font-size: 12px;
      }
      
      .address-inp-icon {
        width: 16px;
        height: 16px;
        position: absolute;
        right: 28px;
      }
      .address-inp {
        background-color: white;
        width: 100%;
        height: 44px;
        padding-right: 28px;
        padding-left: 15px;
        border: 0.5px solid #DFE0E3;;
        border-radius: 4px;
      }
      .label {
        font-size: 14px;
        color: #666666;
        span {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #F94F4E;
        }
      }
      /deep/.content {
        display: flex;
        align-items: center;
        span {
          font-weight: 400;
          font-size: 14px;
          color: #171A1D;
          letter-spacing: 0;
          line-height: 14px;
        }
        .grayfont {
          font-size: 14px;
          color: #cccccc;
        }
        .van-field__control {
          text-align: right;
        }
        .van-radio--horizontal {
          margin-right: 24px;
        }
        .van-radio--horizontal:last-child {
          margin-right: 0;
        }
        .van-radio__label {
          font-size: 14px;
          color: #171a1d;
          margin-left: 8px;
        }
        .van-radio__icon {
          display: flex;
          align-items: center;
          width: 18px;
          height: 18px;
        }
        .arrow {
          font-size: 1px;
          margin-left: 5px;
          color: #A2A3A4;
        }
      }
      /deep/.address-content {
        flex: 1;
        margin-left: 10px;
        .van-field__control {
          max-height: 120px;
        }
      }
      /deep/.setHeight24 {
        textarea{
          height: 24px !important;
        }
      }
    }

    .van-divider {
      margin: 0;
    }

    .noboderboottom {
      border-bottom: 0;
    }
    .child-form {
      padding: 0 17px;
      background-color: #f8fafb;
      .cell {
        padding-left: 0;
        padding-right: 0;
      }
      .paddingBottom0 {
        padding-bottom: 0;
      }
      /deep/.input-cell {
        padding-top: 5px;
        padding-bottom: 5px;
        align-items: baseline;
        .van-field {
          padding-right: 0;
        }
      }
      /deep/.Address-input {
        .van-field__control {
          text-align: left;
        }
      }
    }

    .text-cell {
      position: relative;
      padding-top: 0;
      padding-bottom: 0;
      /deep/.textarea {
        background: white;
        border-radius: 4px;
        padding: 12px 40px 38px 12px;
        width: 100%;
        border: none;
        line-height: 20px;
        min-height: 119px;
        box-sizing: border-box;
        margin-top: 17px;
        .van-field__control {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #1E2226;

        }
      }
       .textarea::-webkit-input-placeholder{
      font-weight: 400;
      font-size: 14px;
      color: #CCCCCC;
      letter-spacing: 0;
      line-height: 14px;
    
    }/*webkit 内核浏览器*/
    .textarea::-moz-placeholder{
      font-weight: 400;
      font-size: 14px;
      color: #CCCCCC;
      letter-spacing: 0;
      line-height: 14px;
 
    }/*Mozilla Firefox 19+*/
    .textarea:-moz-placeholder{
      font-weight: 400;
      font-size: 14px;
      color: #CCCCCC;
      letter-spacing: 0;
      line-height: 14px;
  
    }/*Mozilla Firefox 4 to 18*/
    .textarea:-ms-input-placeholder{
      font-weight: 400;
      font-size: 14px;
      color: #CCCCCC;
      letter-spacing: 0;
      line-height: 14px;
 
    }
      .Fill-in-btn {
        position: absolute;
        background: #36b374;
        border-radius: 4px;
        text-align: center;
        width: 52px;
        right: 12px;
        bottom: 12px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 24px;
      }
      .clear-icon {
        position: absolute;
        top: 28px;
        right: 12px;
        font-size: 16.5px;
        color: #cccccc;
        width: 18px;
        height: 18px;
      }
    }
    .pading-right16 {
      padding-right: 16px;
    }
  }
  .supplement-box {
    position: relative;
    padding: 0;
    .title {
      font-size: 14px;
      color: #666666;
      margin-bottom: 12px;
    }
    /deep/.textarea {
      width: 100%;
      background: #f8f9fb;
      padding: 16px 4px 16px 16px;
      border-radius: 4px 4px 0 0;
      border: 0;
      font-size: 14px;
      line-height: 20px;
      box-sizing: border-box;
      .van-field__control {
        min-height: 120px;
        max-height: 320px;
      }
      .van-field__control::-webkit-scrollbar {
            width: 3px;
        }
        .van-field__control::-webkit-scrollbar-thumb {
            background: #E4E5E8;
        }
        .van-field__control::-webkit-scrollbar-track {
            background: #F8F9FB;
        }
    }
    .textarea::-webkit-input-placeholder{
      font-weight: 400;
      font-size: 14px;
      color: #CCCCCC;
      letter-spacing: 0;
      line-height: 14px;
    
    }/*webkit 内核浏览器*/
    .textarea::-moz-placeholder{
      font-weight: 400;
      font-size: 14px;
      color: #CCCCCC;
      letter-spacing: 0;
      line-height: 14px;
 
    }/*Mozilla Firefox 19+*/
    .textarea:-moz-placeholder{
      font-weight: 400;
      font-size: 14px;
      color: #CCCCCC;
      letter-spacing: 0;
      line-height: 14px;
  
    }/*Mozilla Firefox 4 to 18*/
    .textarea:-ms-input-placeholder{
      font-weight: 400;
      font-size: 14px;
      color: #CCCCCC;
      letter-spacing: 0;
      line-height: 14px;
 
    }
    .tip {
      text-align: right;
      padding: 0 16px 12px 12px;
      background: #f8f9fb;
      width: 100%;
      position: relative;
      top: -15px;
      font-size: 14px;
      color: #cccccc;
      border-radius: 0 0 4px 4px;
      line-height: 25px;
      display: flex;
      justify-content: space-between;
      .clear {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #36B374;
      }
    }

  }
  .confirmbtn {
      background: #36b374;
      border-radius: 4px;
      text-align: center;
      right: 12px;
      bottom: 12px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 48px;
    }
  .assignPersonnelPicker-box {
    padding: 0 16px;
    .header {
      padding: 20px 0;
      display: flex;
      justify-content: space-between;

      font-family: PingFangSC-S0pxibold;
      font-weight: 600;
      font-size: 16px;
      color: #171A1D;
      line-height: 16px;
      .van-icon-arrow-down:before {
        font-size: 16px;
      }
      .title {
        font-size: 16px;
        color: #171a1d;
      }
    }
    .tab-box {
      display: flex;
      border-bottom: 1px solid #f5f6f9;
      padding-top: 10px;
      .tab {
        margin-right: 21px;
        font-size: 14px;
        color: #666666;
        padding-bottom: 14.5px;
      }
      .tab-active {
        margin-right: 21px;
        font-size: 14px;
        color: #171a1d;
        padding-bottom: 14.5px;
        border-bottom: 1px solid #36b374;
      }
    }
    .person-list {
      max-height: 350px;
      overflow: auto;
      padding-bottom: 50px;
      &::-webkit-scrollbar {
        display: none;
      }
      .person-item {
        padding: 20px 0;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #f5f6f9;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #171A1D;
        line-height: 16px;
        .select-icon {
          height: 18px;
          width: 18px;
        }
      }
    }
    .box1 {
      text-align: center;
      margin-top: 64px;
      padding-bottom: 87px;
      img {
        display: inline-block;
        width: 74px;
        height: 62px;
      }
      .tip1 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 24px;
      }
      .tip2 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 8px;
      }
    }
  }
  .btn {
    position: fixed;
    // bottom: constant(safe-area-inset-bottom);
    // bottom: env(safe-area-inset-bottom);
    bottom: 34px;
    left: 50%;
    transform: translateX(-50%);
    background: #36b374;
    border-radius: 4px;
    color: white;
    padding: 0 16px;
    text-align: center;
    font-size: 16px;
    padding: 16px 0;
    color: white;
    width: 92%;
  }
}
/deep/.secondary-cell {
  background-color: #F8F9FC;

  .van-cell {
    background-color: #f8fafb;
  }
}

</style>
